export const SlHomeContext = 'mf_slhome_container_context';
